import { render, staticRenderFns } from "./DappDetailedTablesHeader.vue?vue&type=template&id=f3cb398c&scoped=true"
import script from "./DappDetailedTablesHeader.vue?vue&type=script&lang=ts"
export * from "./DappDetailedTablesHeader.vue?vue&type=script&lang=ts"
import style0 from "./DappDetailedTablesHeader.vue?vue&type=style&index=0&id=f3cb398c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cb398c",
  null
  
)

export default component.exports